<template>
  <div id="App" class="h-100 d-flex flex-column">
    <router-view name="appBar" />
    <transition name="page" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: "SWISS ECO BAGS ™",
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.$t("description") ,
        },
      ],
    };
  },
};
</script>

<style lang="scss">
@import "../node_modules/line-awesome/dist/line-awesome/css/line-awesome.css";
@import "@/styles/app.scss";
</style>
